import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
const isFor = ['Mujeres de 30 a 55 años que se sienten "estancadas" con su peso.', 'Mujeres que sufren de colon irritable o digestiones lentas.', 'Profesionales con altos niveles de estrés que necesitan claridad mental.', 'Cualquiera que quiera verse y sentirse ligera sin pasar hambre.'];
const isNotFor = ['Personas que buscan "pastillas mágicas" para adelgazar sin cambiar hábitos.', 'Atletas de alto rendimiento buscando planes de competición.', 'Personas que no están dispuestas a dejar los ultraprocesados por 21 días.'];
export function WhoIsItFor() {
  return <section className="py-6 md:py-28 bg-white" data-id="element-233">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-234">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-235">
          {/* Para quién ES */}
          <FadeIn direction="right" data-id="element-236">
            <div className="bg-sage-50 rounded-3xl p-8 md:p-10 h-full border border-sage-100" data-id="element-237">
              <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-8 text-center lg:text-left" data-id="element-238">
                Para quién{' '}
                <span className="text-sage-600 underline decoration-sage-300 underline-offset-4" data-id="element-239">
                  SÍ
                </span>{' '}
                es esto
              </h3>
              <ul className="space-y-6" data-id="element-240">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-241">
                    <div className="flex-shrink-0 mt-1" data-id="element-242">
                      <div className="w-6 h-6 rounded-full bg-sage-200 flex items-center justify-center" data-id="element-243">
                        <Check className="w-4 h-4 text-sage-700" strokeWidth={3} data-id="element-244" />
                      </div>
                    </div>
                    <span className="text-lg text-charcoal-light leading-relaxed" data-id="element-245">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO ES */}
          <FadeIn direction="left" delay={0.2} data-id="element-246">
            <div className="bg-cream-200 rounded-3xl p-8 md:p-10 h-full border border-cream-300" data-id="element-247">
              <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-8 text-center lg:text-left" data-id="element-248">
                Para quién{' '}
                <span className="text-coral-500 underline decoration-coral-300 underline-offset-4" data-id="element-249">
                  NO
                </span>{' '}
                es esto
              </h3>
              <ul className="space-y-6" data-id="element-250">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-251">
                    <div className="flex-shrink-0 mt-1" data-id="element-252">
                      <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center" data-id="element-253">
                        <X className="w-4 h-4 text-coral-600" strokeWidth={3} data-id="element-254" />
                      </div>
                    </div>
                    <span className="text-lg text-charcoal-light leading-relaxed" data-id="element-255">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}